// SPDX-License-Identifier: MIT
import { t } from '../i18n/t';

const STORAGE_KEY = 'devBandOpen';

function getStored(): boolean {
  try { return localStorage.getItem(STORAGE_KEY) === 'true'; }
  catch { return false; }
}

function setStored(open: boolean): void {
  try { localStorage.setItem(STORAGE_KEY, String(open)); } catch { /* noop */ }
}

const CARD_KEYS = ['runtime', 'stack', 'license', 'plugin', 'providers', 'platform'] as const;

export function renderDevBand(): HTMLElement {
  let isOpen = getStored();
  const el = document.createElement('section');
  el.className = `dev-band${isOpen ? ' dev-band--expanded' : ''}`;
  el.innerHTML = buildMarkup(isOpen);
  el.querySelector<HTMLElement>('.dev-band__teaser')!.addEventListener('click', () => {
    isOpen = !isOpen;
    setStored(isOpen);
    el.classList.toggle('dev-band--expanded', isOpen);
    el.querySelector<HTMLElement>('.dev-band__bento')!.hidden = !isOpen;
    el.querySelector<HTMLElement>('.dev-band__teaser-cta')!.textContent =
      isOpen ? t('devBand.teaserCtaOpen') : t('devBand.teaserCta');
  });
  return el;
}

function buildMarkup(isOpen: boolean): string {
  const cards = CARD_KEYS.map((key) => {
    const isPaid = key === 'platform';
    const badge = isPaid
      ? `<span class="bento-card__badge">${t('devBand.cards.platform.badge')}</span>`
      : '';
    return `
      <article data-component="bento-card" class="bento-card${isPaid ? ' bento-card--paid' : ''}" data-accent="${key}">
        ${badge}
        <div class="bento-card__label">${t(`devBand.cards.${key}.label`)}</div>
        <div class="bento-card__title">${t(`devBand.cards.${key}.title`)}</div>
        <div class="bento-card__meta">${t(`devBand.cards.${key}.meta`)}</div>
      </article>
    `;
  }).join('');
  return `
    <button class="dev-band__teaser" type="button">
      <span class="dev-band__teaser-prompt">${t('devBand.teaserPrompt')}</span>
      <div class="dev-band__teaser-divider"></div>
      <span class="dev-band__teaser-cta">${isOpen ? t('devBand.teaserCtaOpen') : t('devBand.teaserCta')}</span>
    </button>
    <div class="dev-band__bento"${isOpen ? '' : ' hidden'}>
      <div class="dev-band__halftone" aria-hidden="true"></div>
      <div class="dev-band__speed-lines" aria-hidden="true">
        <span class="speed-line speed-line--1"></span>
        <span class="speed-line speed-line--2"></span>
        <span class="speed-line speed-line--3"></span>
        <span class="speed-line speed-line--4"></span>
      </div>
      <header class="dev-band__header">
        <div>
          <h2 class="dev-band__heading">${t('devBand.heading')}</h2>
          <div class="dev-band__tagline">${t('devBand.tagline')}</div>
        </div>
        <div class="dev-band__status">
          <span class="dev-band__live">● ${t('devBand.liveLabel')}</span>
          <span class="dev-band__build">${t('devBand.buildLabel')} <strong>v2.1.0</strong></span>
        </div>
      </header>
      <div class="dev-band__cards">${cards}</div>
      <footer class="dev-band__footer">
        <div class="dev-band__footer-divider"></div>
        <div class="dev-band__footer-row">
          <div class="dev-band__links">
            <a class="dev-band__link" href="https://github.com/myconciergerie-prog/project-genesis" target="_blank" rel="noopener noreferrer">${t('devBand.links.github')}</a>
            <span class="dev-band__sep">|</span>
            <a class="dev-band__link" href="#marketplace">${t('devBand.links.marketplace')}</a>
            <span class="dev-band__sep">|</span>
            <a class="dev-band__link" href="#docs">${t('devBand.links.docs')}</a>
          </div>
          <div class="dev-band__footer-end">
            <span class="dev-band__live-dot">●</span> <strong>MIT</strong> <span class="dev-band__sep">|</span> by myconciergerie
          </div>
        </div>
      </footer>
    </div>
  `;
}
